import { Fragment } from 'react';
import { Box, Grid, Typography } from '@mui/material';

import SectionTitle from '../../components/SectionTitle';

const CVCfive = () => {
  const info = [
    'Nếu chảy máu vẫn tiếp tục tại vị trí chèn.',
    'Nếu vị trí chèn chuyển sang màu đỏ hoặc có dấu hiệu chảy mủ.',
    'Nếu có hơi nóng hoặc đau tại vị trí chèn.',
    'Nếu có tê hoặc đau ở vị trí chèn, vai, hoặc cánh tay.',
    'Nếu có chỗ sưng ở mặt, vai, hoặc cánh tay bên cạnh chèn.',
    'Nếu ống thông trở nên dài hơn hoặc bị bung ra.',
    'Nếu chỗ khâu đã mở ra.',
    'Nếu ống thông bị hỏng (bị rách hoặc thủng).',
    'Nếu nhiệt độ tăng lên trên 38 độ C.',
  ];

  return (
    <Fragment>
      <SectionTitle title="5. Tình huống cần báo cáo cho cán bộ y tế." />
      <Box sx={{ margin: '38px 0px 30px 20px' }}>
        <Grid container xs={11.8}>
          {info.map(a => {
            return (
              <Grid item xs={11.5}>
                <Typography sx={{ fontSize: '14px', lineHeight: '30px' }}>
                  • {a}
                </Typography>
              </Grid>
            );
          })}
          <Typography
            sx={{
              fontSize: '14px',
              lineHeight: '30px',
              fontWeight: 500,
              marginTop: '40px',
            }}
          >
            Tôi đã hiểu đầy đủ lời giải thích và sự đồng ý cho việc chèn ống
            thông tĩnh mạch trung tâm.
          </Typography>
        </Grid>
      </Box>
    </Fragment>
  );
};

export default CVCfive;
